import {Component, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-availability-contact-sales',
    templateUrl: './availability-contact-sales.component.html',
    standalone: false
})
export class AvailabilityContactSalesComponent {

  @Output()
  public selected = new EventEmitter<void>()

  constructor() { }

  public onBackOverview() {
    this.selected.emit();
  }
}
